import styles from './delete-contacts-error-dialog.module.scss';
import { useContext } from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle, GrayOutlinedButton, SecondaryButton, SnackBarContext, Typography } from '@frontend-workspace/react-shared-lib';
import { useTranslation } from 'react-i18next';
import { useMakeRequestHook } from '../../requestUtils';

/* eslint-disable-next-line */
export interface DeleteContactsErrorDialogProps {
  open: boolean,
  onClose: () => void,
  orderId: string
}

export function DeleteContactsErrorDialog(props: DeleteContactsErrorDialogProps) {
  const { t } = useTranslation();
  const { setSnackbarMessage } = useContext(SnackBarContext);
  const makeRequest = useMakeRequestHook();

  const handleDeleteContactsError = () => {
    makeRequest(`orders/${props.orderId}/action/setToManuallyHandled`, 'PUT')
      .then(result => {
        setSnackbarMessage({ content: t("deleteContactsError.errorMessageSetAsHandled"), type: "success" });
        props.onClose();
      }).catch(() => setSnackbarMessage({ content: t("deleteContactsError.couldNotSetErrorMessageAsHandled"), type: "error" }));
  };

  return (
    <Dialog
      open={props.open}
      onClose={() => props.onClose()}
      maxWidth='md'>
      <DialogTitle className='mb-3'>
        {t("deleteContactsError.areYouSureYouWantToSetAsHandled")}
      </DialogTitle>
      <DialogContent>
        <Typography
          component="div"
          variant='subtitle3'>
          {t("deleteContactsError.errorMessageIsSetAsHandledInDatabase")}
        </Typography>
      </DialogContent>
      <DialogActions>
        <SecondaryButton
          variant="contained"
          size='large'
          onClick={handleDeleteContactsError}
          className='minButtonWidth'>
          {t("standard.setAsHandled")}
        </SecondaryButton>
        <GrayOutlinedButton
          variant="outlined"
          size='large'
          onClick={props.onClose}
          className='minButtonWidth'>
          {t("standard.cancel")}
        </GrayOutlinedButton>
      </DialogActions>
    </Dialog>
  );
}

export default DeleteContactsErrorDialog;